var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCommentsBlueDouble = function SvgIconCommentsBlueDouble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-comments",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M472.667 100.1v-2.117a4.331 4.331 0 0 0-1-8.546h-3.334a4.333 4.333 0 0 0 0 8.667h1Z",
    transform: "translate(-460 -84.104)",
    fill: "#bee6fa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M466.667 92.771h1a4.334 4.334 0 0 0 0-8.667h-3.334a4.331 4.331 0 0 0-1 8.546v2.121Z",
    transform: "translate(-460 -84.104)",
    fill: "#1eaae1"
  })));
};
export { SvgIconCommentsBlueDouble as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1jb21tZW50cyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggaWQ9IlBhdGhfMTIxIiBkYXRhLW5hbWU9IlBhdGggMTIxIiBkPSJNNDcyLjY2NywxMDAuMVY5Ny45ODNhNC4zMzEsNC4zMzEsMCwwLDAtMS04LjU0NmgtMy4zMzRhNC4zMzMsNC4zMzMsMCwwLDAsMCw4LjY2N2gxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ2MCAtODQuMTA0KSIgZmlsbD0iI2JlZTZmYSIvPgogIDxwYXRoIGlkPSJQYXRoXzEyMiIgZGF0YS1uYW1lPSJQYXRoIDEyMiIgZD0iTTQ2Ni42NjcsOTIuNzcxaDFhNC4zMzQsNC4zMzQsMCwwLDAsMC04LjY2N2gtMy4zMzRhNC4zMzEsNC4zMzEsMCwwLDAtMSw4LjU0NnYyLjEyMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00NjAgLTg0LjEwNCkiIGZpbGw9IiMxZWFhZTEiLz4KPC9zdmc+Cg==";